import { Grid, Paper } from '@mui/material'
import React, { useEffect, useState } from 'react'
import UtilizationMonthlyTrends from '../components/UtilizationMonthlyTrends'
import { LeasesBasicDetails, LeasesNav } from '../../elements'
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal'
import BackToLeaseList from '../../elements/BackToLeaseList'
import ClaimsAndShopVisits from '../components/ClaimsAndShopVisits'
import { useParams } from 'react-router'
import FilterCard from '../components/FilterCard'
import moment from 'moment'
import { backendDateFormat } from '../../../constants'
import CashflowAndForwardBilling from '../components/CashflowAndForwardBilling'
import { PageLoader } from '../../../shared_elements'
import useContractAnalyticsApiHook from '../hooks/useContractAnalyticsApiHook'
import InvoiceAndPaymentTrends from '../components/InvoiceAndPaymentTrends'
import ComplainceContractEventsRedelivery from '../components/ComplainceContractEventsRedelivery';
import MaintenanceReserveFunds from '../components/MaintenanceReserveFunds'
import { RoleBaseAccess } from '../../../hoc'
import ContractHealthOverView from '../components/ContractHealthOverView'

const ContractAnalytics = () => {
  const params = useParams();
  const [assetData,setAssetData]=useState({});
  const [utilType, setUtilType] = useState('both');
  const [utilVal, setUtilVal] = useState('quarterly')
  const [invVal, setInvVal] = useState('quarterly')
  const [invDateType,setInvDateType]=useState('due_date')
  const [eventType, setEventType] = useState('')
  const [filterData, setFilterData] = useState({});
  const [error, setError] = useState({});
  const { leaseBasicDetails, loading, data, currencies, dropDownLoader, getDefaultDateRange, getMonthlyUtilizationData, getAverageUtilizationData, getInvPaymentTrendsData, fetchAllContractAnalytics, getCurrencyData, getFundMovementWaterfallData, } = useContractAnalyticsApiHook(params, utilType, utilVal);

  const getDateRangeQuery = () => (
    filterData?.date_from || filterData?.date_to
      ? {
        ...(filterData?.date_from && { date_from: moment(filterData.date_from).format(backendDateFormat) }),
        ...(filterData?.date_to && { date_to: moment(filterData.date_to).format(backendDateFormat) }),
      }
      : getDefaultDateRange()
  )

  useEffect(()=>{
    fetchAllContractAnalytics({ lease_slug: params?.leaseSlug, ...getDefaultDateRange() });
    // getInvPaymentTrendsData({ lease_slug: params?.leaseSlug, date_type: invDateType, frequency: invVal, ...getDateRangeQuery() })
    getCurrencyData();
  },[])

  useEffect(() => {
    if (leaseBasicDetails?.asset){
      setAssetData({asset_id: leaseBasicDetails?.asset?.id, asset_type: leaseBasicDetails?.asset?.asset_type,  });
      getMonthlyUtilizationData({ lease_slug: params?.leaseSlug, asset_id: leaseBasicDetails?.asset?.id, asset_type: leaseBasicDetails?.asset?.asset_type, ...getDateRangeQuery() })
    }
  }, [leaseBasicDetails])

  const onAssetChange=(asset)=>{
          setAssetData(asset);
          getMonthlyUtilizationData({ lease_slug: params?.leaseSlug, asset_id: asset?.asset_id, asset_type: asset?.asset_type, ...getDateRangeQuery() })
  }
  const onMetricChange = (metric) => {
          setUtilType(metric);
  }
  const onPeriodChange = (period) => {
          setUtilVal(period);
          delete data?.average_utilization;
          getAverageUtilizationData({ lease_slug: params?.leaseSlug, period, ...getDateRangeQuery() })
  }
  const onInvoiceDateTypeChange = (dateType) => {
          setInvDateType(dateType);
          delete data?.invoice_payments;
          // getInvPaymentTrendsData({ lease_slug: params?.leaseSlug, date_type: dateType, frequency: invVal, ...getDateRangeQuery() })
  }
  const onInvoicePeriodChange = (frequency) => {
          setInvVal(frequency);
          delete data?.invoice_payments;
          // getInvPaymentTrendsData({ lease_slug: params?.leaseSlug, date_type: invDateType, frequency, ...getDateRangeQuery() })
  }
  const onEventTypeChange = (value) => {
    setEventType(value);
    // getFundMovementWaterfallData({ lease_slug: params?.leaseSlug, ...getDateRangeQuery(), ...(value && { event_type: value }) })
  }
  const onFieldChange = (key, value) => { setFilterData(prev => ({ ...prev, [key]: value })) }
  const onFocusChange = (key) => { setError({ ...error, [key]: "" }) }

  const validateDate = (value, fieldLabel) => {
    if (!value) return "";
    const leaseStartDate = moment(leaseBasicDetails?.start_date);
    const leaseEndDate = moment(leaseBasicDetails?.end_date);
    const date = moment(value);

    if (!date.isValid()) {
      return `Please select valid ${fieldLabel}`;
    }
    if (!leaseStartDate?.isValid() || !leaseEndDate?.isValid()) {
      return "";
    }
    return date.isBetween(leaseStartDate, leaseEndDate, "day", "[]")
      ? ""
      : `${fieldLabel} must be within the lease period`;
  };

  const onApplyFilter = () => {
    let validationInputs = {
      date_from: validateDate(filterData?.date_from, 'Date From'),
      date_to: validateDate(filterData?.date_to, 'Date To'),
    }
    const DateFrom = filterData?.date_from ? moment(filterData?.date_from) : null;
    const DateTo = filterData?.date_to ? moment(filterData?.date_to) : null;
    if(DateFrom && DateTo && DateTo.isBefore(DateFrom)){
      validationInputs.date_from = 'Date From cannot be before Date To'
      validationInputs.date_to = 'Date To cannot be after Date From'
    } 
    if (Object.keys(validationInputs).every(k => validationInputs[k] === "")) {
      const query = {
        lease_slug: params?.leaseSlug,
        ...(filterData?.date_from && { date_from: moment(filterData?.date_from).format(backendDateFormat) }),
        ...(filterData?.date_to && { date_to: moment(filterData?.date_to).format(backendDateFormat) }),
        ...(filterData?.display_currency_id && {
          display_currency_id: filterData.display_currency_id.value,
        }),
      };
      fetchAllContractAnalytics(query);
      if (assetData) getMonthlyUtilizationData({...query, asset_id: assetData?.asset_id, asset_type: assetData?.asset_type })
      // getInvPaymentTrendsData({...query, lease_slug: params?.leaseSlug, date_type: invDateType, frequency: invVal })
      // getFundMovementWaterfallData({ ...query, ...(eventType && { event_type: eventType }) })
    }
    else setError(validationInputs);
  }
  const onResetFilter = () => {
    setError({});
    setFilterData({});
    fetchAllContractAnalytics({ lease_slug: params?.leaseSlug, ...getDefaultDateRange() })
    if (assetData) getMonthlyUtilizationData({ lease_slug: params?.leaseSlug, asset_id: assetData?.asset_id, asset_type: assetData?.asset_type, ...getDefaultDateRange() })
    getInvPaymentTrendsData({ lease_slug: params?.leaseSlug, date_type: invDateType, frequency: invVal, ...getDateRangeQuery() })
    getFundMovementWaterfallData({ lease_slug: params?.leaseSlug, ...getDefaultDateRange(), ...(eventType && { event_type: eventType }) })
  }

  return (
    <>
      <LeasesBasicDetails />
      <Paper className='lease-details-section lease-nav-module-margin' elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }} square>
        <LeasesNav />
        {leaseBasicDetails?.status === 'Draft' ? (<ModuleNotExcessModal moduleName="Claim Management" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
          <div className='lease-details-content lease-content-overflow'>
            <Paper square className="responsive-paper">
              <Grid container spacing={1} className="responsive-grid" alignItems='end'>
                <Grid item size={{ md: 12, xs: 12 }} sx={{ marginBottom: "-15px", marginLeft: "3px" }} className="menu-container lease-list-link-mt">
                  <BackToLeaseList />
                </Grid>
              </Grid>
            </Paper>
            <Paper sx={{ margin: '10px 0px 5px 0px', padding: "5px", background: '#f9fafb', height: "calc(100vh - 200px)", overflow: 'auto' }}>
              <Grid container>
                <Grid size={{ md: 12, xs: 12 }}>
                  <FilterCard dropDownLoader={dropDownLoader} filterData={filterData} onFieldChange={onFieldChange} onFocusChange={onFocusChange} onApplyFilter={onApplyFilter} onResetFilter={onResetFilter} error={error} currencies={currencies} />
                </Grid>
                {/* <Grid size={{ md: 12, xs: 12 }} mb={1}>
                  <ContractHealthOverView data={data} loading={loading} />
                </Grid> */}
                <Grid item size={{ md: 12, xs: 12 }}>
                  <UtilizationMonthlyTrends utilizationData={data} assetData={assetData} onAssetChange={onAssetChange} utilType={utilType} onMetricChange={onMetricChange} utilVal={utilVal} onPeriodChange={onPeriodChange} isLoading={loading} />
                </Grid>
                <Grid item size={{ md: 12, xs: 12 }}>
                  <ComplainceContractEventsRedelivery data={data} loading={loading} />
                </Grid>
                {/* <Grid item size={{ md: 12, xs: 12 }}>
                  <InvoiceAndPaymentTrends invPaymentsData={data} invVal={invVal} invDateType={invDateType} onInvDateTypeChange={onInvoiceDateTypeChange} onInvPeriodChange={onInvoicePeriodChange} isLoading={loading} />
                </Grid>
                <Grid item size={{ md: 12, xs: 12 }}>
                  <CashflowAndForwardBilling cashflowData={data} loading={loading} />
                </Grid>
                <Grid item size={{ md: 12, xs: 12 }}>
                  <MaintenanceReserveFunds maintenanceData={data} isLoading={loading} eventType={eventType} onEventTypeChange={onEventTypeChange} />
                </Grid>
                <Grid item size={{ md: 12, xs: 12 }}>
                  <ClaimsAndShopVisits claimsData={data} loading={loading} />
                </Grid>
                 */}
              </Grid>
            </Paper>

          </div>}
      </Paper>
      {loading?.claim_status_recovery ? <PageLoader /> : null }
    </>
  )
}

export default RoleBaseAccess(ContractAnalytics, { application: 'lease_revamp', feature: 'statistics', operationType: ['R'] });